/**
 * Game types and interfaces for Tic-Tac-Toe
 */

export type Player = 'X' | 'O';
export type CellValue = Player | null;
export type Board = [
  CellValue,
  CellValue,
  CellValue,
  CellValue,
  CellValue,
  CellValue,
  CellValue,
  CellValue,
  CellValue,
];

export type GameStatus = 'waiting' | 'playing' | 'won' | 'draw';

export interface GameState {
  board: Board;
  currentPlayer: Player;
  localPlayer: Player;
  status: GameStatus;
  winner: Player | null;
  isMyTurn: boolean;
}

export type GameAction =
  | { type: 'MAKE_MOVE'; payload: { position: number } }
  | { type: 'RECEIVE_MOVE'; payload: { position: number; player: Player } }
  | { type: 'START_GAME'; payload: { localPlayer: Player } }
  | { type: 'RESET_GAME' }
  | { type: 'SET_WAITING' };

export interface GameMove {
  position: number;
  player: Player;
  timestamp: number;
}

export const WINNING_COMBINATIONS = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8], // rows
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8], // columns
  [0, 4, 8],
  [2, 4, 6], // diagonals
] as const;
